import React, { useState, useEffect, useCallback } from 'react';
import { safeJson, networkMessage } from '../apiHelpers';
import { MilestoneBuilder } from './Milestones';

const C = {
  primary: '#0F6E56', primaryBg: '#E1F5EE', border: '#E3E1D9',
  text: '#1F1E1B', muted: '#5F5E5A', surface: '#F7F5F0',
  gold: '#91600C', danger: '#C0392B',
};

const API = '/api/freelance';

function authHeaders() {
  const t = localStorage.getItem('token') || '';
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) };
}

/** `user` prop har component tak nahi pohanchta - khud nikaal lo. */
function myUsername() {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const u = JSON.parse(raw);
      if (u && u.username) return u.username;
    }
  } catch (e) {}
  return localStorage.getItem('username') || '';
}

function ago(iso) {
  if (!iso) return '';
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 3600) return Math.floor(s / 60) + 'm ago';
  if (s < 86400) return Math.floor(s / 3600) + 'h ago';
  return Math.floor(s / 86400) + 'd ago';
}

const btn = {
  fontSize: 11.5, padding: '5px 11px', border: `1px solid ${C.border}`,
  borderRadius: 7, background: '#fff', cursor: 'pointer', color: C.muted,
};
const inp = {
  width: '100%', padding: '7px 10px', fontSize: 13, border: `1px solid ${C.border}`,
  borderRadius: 7, boxSizing: 'border-box', marginBottom: 7,
};

/** Client: gig page par apna kaam bhejne ka form. */
export function CustomRequestForm({ gig, onDone }) {
  const [open, setOpen] = useState(false);
  const [brief, setBrief] = useState('');
  const [budget, setBudget] = useState('');
  const [days, setDays] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const me = myUsername();
  const owner = gig ? (gig.freelancer_username || gig.freelancer || '') : '';
  if (!me || !gig || me === owner) return null;

  const send = async () => {
    if (brief.trim().length < 20) { setMsg('Please describe the work a bit more (20+ characters).'); return; }
    setBusy(true); setMsg('');
    try {
      const res = await fetch(`${API}/custom/request/`, {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({
          freelancer: owner,
          gig_id: gig.id,
          brief,
          budget_pi: parseFloat(budget) || 0,
          needed_in_days: parseInt(days, 10) || 0,
        }),
      });
      const j = await safeJson(res);
      if (!res.ok) throw new Error(j.error || 'Could not send.');
      setMsg('Sent. The freelancer will reply with a price and a timeline.');
      setBrief(''); setBudget(''); setDays('');
      setTimeout(() => { setOpen(false); setMsg(''); if (onDone) onDone(); }, 2200);
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)}
        style={{ ...btn, color: C.primary, borderColor: C.primary, fontWeight: 600, marginTop: 6 }}>
        {'\u{1F4CB}'} Request a custom offer
      </button>
    );
  }

  return (
    <div style={{ background: C.surface, borderRadius: 9, padding: 11, marginTop: 8 }}>
      <p style={{ margin: '0 0 3px', fontSize: 13, fontWeight: 700 }}>Tell them what you need</p>
      <p style={{ margin: '0 0 8px', fontSize: 11, color: C.muted }}>
        For work that does not fit the packages. They will reply with their own price and timeline.
      </p>
      <textarea value={brief} onChange={(e) => setBrief(e.target.value)} rows={4}
        placeholder="What do you need? Be specific - size, style, quantity, deadline…"
        style={{ ...inp, resize: 'vertical' }} />
      <div style={{ display: 'flex', gap: 7 }}>
        <input value={budget} onChange={(e) => setBudget(e.target.value)} type="number" step="0.01"
          placeholder="Budget in Pi (optional)" style={inp} />
        <input value={days} onChange={(e) => setDays(e.target.value)} type="number"
          placeholder="Needed in (days)" style={inp} />
      </div>
      {msg && <p style={{ fontSize: 11.5, color: msg.startsWith('Sent') ? C.primary : C.danger, margin: '0 0 7px' }}>{msg}</p>}
      <div style={{ display: 'flex', gap: 6 }}>
        <button onClick={send} disabled={busy}
          style={{ ...btn, background: C.primary, color: '#fff', borderColor: C.primary, fontWeight: 700 }}>
          {busy ? 'Sending…' : 'Send request'}
        </button>
        <button onClick={() => { setOpen(false); setMsg(''); }} style={btn}>Cancel</button>
      </div>
    </div>
  );
}

/** Dono taraf ka sab kuch - requests aur offers. */
export default function CustomOffersTab() {
  const [d, setD] = useState(null);
  const [replyTo, setReplyTo] = useState(null);
  const [form, setForm] = useState({ title: '', description: '', price_pi: '', delivery_days: 3, revisions: 1 });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [msRows, setMsRows] = useState([]);

  const load = useCallback(() => {
    fetch(`${API}/custom/mine/`, { headers: authHeaders() })
      .then((r) => r.json()).then(setD).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const sendOffer = async (reqId) => {
    setBusy(true); setMsg('');
    try {
      const res = await fetch(`${API}/custom/offer/`, {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({
          request_id: reqId,
          title: form.title,
          description: form.description,
          price_pi: parseFloat(form.price_pi) || 0,
          delivery_days: parseInt(form.delivery_days, 10) || 3,
          revisions: parseInt(form.revisions, 10) || 0,
          milestones: msRows.filter((r) => r.title && parseFloat(r.amount_pi) > 0),
        }),
      });
      const j = await safeJson(res);
      if (!res.ok) throw new Error(j.error || 'Could not send the offer.');
      setReplyTo(null);
      setForm({ title: '', description: '', price_pi: '', delivery_days: 3, revisions: 1 });
      setMsRows([]);
      load();
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  const accept = async (o) => {
    if (!window.confirm(`Accept this offer?\n\n${o.title}\n${o.price_pi} Pi · ${o.delivery_days} days · ${o.revisions} revisions\n\nYou will pay with Pi on the next screen.`)) return;
    try {
      const res = await fetch(`${API}/custom/offer/${o.id}/accept/`, {
        method: 'POST', headers: authHeaders(),
      });
      const j = await safeJson(res);
      if (!res.ok) throw new Error(j.error || 'Could not accept.');

      if (j.free) {
        alert('Order created (free - super admin).');
        load();
        return;
      }

      if (!window.Pi) {
        alert(`Order created. Open it under Orders to pay ${j.price_pi} Pi.`);
        load();
        return;
      }

      const orderId = j.order_id;
      await window.Pi.authenticate(['username', 'payments'], (payment) => {
        const md = (payment && payment.metadata) || {};
        if (!md.order_id) return;
        const tx = payment.transaction && payment.transaction.txid;
        fetch(`/api/freelance/orders/${md.order_id}/${tx ? 'complete' : 'approve'}/`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify(tx ? { payment_id: payment.identifier, txid: tx }
                                  : { payment_id: payment.identifier }),
        }).catch(() => {});
      });

      window.Pi.createPayment(
        { amount: j.price_pi, memo: `Custom order: ${o.title}`.slice(0, 100),
          metadata: { type: 'freelance_order', order_id: orderId } },
        {
          onReadyForServerApproval: (pid) => {
            fetch(`/api/freelance/orders/${orderId}/approve/`, {
              method: 'POST', headers: authHeaders(),
              body: JSON.stringify({ payment_id: pid }) });
          },
          onReadyForServerCompletion: (pid, txid) => {
            fetch(`/api/freelance/orders/${orderId}/complete/`, {
              method: 'POST', headers: authHeaders(),
              body: JSON.stringify({ payment_id: pid, txid }) })
              .then(() => { alert('Paid. The freelancer can start now.'); load(); })
              .catch(() => alert('Payment reached Pi but the order did not activate. Contact support.'));
          },
          onCancel: () => { alert('Payment cancelled. The order is under Orders - pay any time.'); load(); },
          onError: () => { alert('Payment failed. The order is saved - try again from Orders.'); load(); },
        }
      );
    } catch (e) { alert(networkMessage(e)); }
  };

  const action = async (o, act) => {
    if (!window.confirm(act === 'decline' ? 'Decline this offer?' : 'Withdraw your offer?')) return;
    try {
      const res = await fetch(`${API}/custom/offer/${o.id}/action/`, {
        method: 'POST', headers: authHeaders(), body: JSON.stringify({ action: act }),
      });
      const j = await safeJson(res);
      if (!res.ok) throw new Error(j.error || 'Failed');
      load();
    } catch (e) { alert(networkMessage(e)); }
  };

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '1.5rem 0' }}>Loading…</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '1.5rem 0' }}>{d.error}</p>;

  const empty = !d.requests_sent.length && !d.requests_received.length
             && !d.offers_sent.length && !d.offers_received.length;

  const OfferCard = ({ o, mine }) => (
    <div style={{ background: '#fff', border: `1px solid ${o.is_live ? C.primary : C.border}`,
                  borderRadius: 9, padding: '10px 12px', marginBottom: 7 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 13.5, fontWeight: 700 }}>{o.title}</span>
        <span style={{ fontSize: 15, fontWeight: 700, color: C.primary }}>{o.price_pi} Pi</span>
      </div>
      <p style={{ margin: '3px 0', fontSize: 11.5, color: C.muted }}>
        {mine ? `to @${o.client}` : `from @${o.freelancer}`} · {o.delivery_days} days ·
        {' '}{o.revisions} revisions · {ago(o.created_at)}
      </p>
      <p style={{ margin: '5px 0', fontSize: 12.5, color: C.text, whiteSpace: 'pre-wrap' }}>{o.description}</p>
      {o.milestones && o.milestones.length > 0 && (
        <div style={{ background: C.surface, borderRadius: 6, padding: '6px 8px', margin: '5px 0' }}>
          <p style={{ margin: '0 0 3px', fontSize: 10.5, fontWeight: 700, color: C.muted }}>
            {'\u{1F3AF}'} {o.milestones.length} milestones
          </p>
          {o.milestones.map((ms, i) => (
            <p key={i} style={{ margin: '1px 0', fontSize: 11, color: C.text }}>
              {i + 1}. {ms.title} — <b>{ms.amount_pi} Pi</b> · {ms.delivery_days}d
            </p>
          ))}
        </div>
      )}

      {o.status !== 'pending' && (
        <p style={{ margin: '4px 0 0', fontSize: 11, fontWeight: 700,
                    color: o.status === 'accepted' ? C.primary : C.muted }}>
          {o.status}{o.order_id ? ` · order #${o.order_id}` : ''}
        </p>
      )}

      {o.is_live && (
        <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
          {mine ? (
            <button onClick={() => action(o, 'withdraw')} style={{ ...btn, color: C.danger, borderColor: C.danger }}>
              Withdraw
            </button>
          ) : (
            <>
              <button onClick={() => accept(o)}
                style={{ ...btn, background: C.primary, color: '#fff', borderColor: C.primary, fontWeight: 700 }}>
                Accept &amp; order
              </button>
              <button onClick={() => action(o, 'decline')} style={{ ...btn, color: C.danger, borderColor: C.danger }}>
                Decline
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div>
      {empty && (
        <p style={{ textAlign: 'center', color: C.muted, fontSize: 12.5, padding: '2rem 1rem' }}>
          No custom offers yet.<br />
          Open a gig and tap <b>Request a custom offer</b> for work that does not fit the packages.
        </p>
      )}

      {d.requests_received.length > 0 && (
        <>
          <p style={{ fontSize: 12.5, fontWeight: 700, margin: '4px 0 7px' }}>
            {'\u{1F4E5}'} Requests for you
          </p>
          {d.requests_received.map((r) => (
            <div key={r.id} style={{ background: '#fff', border: `1px solid ${C.border}`,
                                     borderRadius: 9, padding: '10px 12px', marginBottom: 7 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12.5, fontWeight: 600 }}>@{r.client}</span>
                <span style={{ fontSize: 11, color: C.muted }}>
                  {r.budget_pi ? `budget ${r.budget_pi} Pi · ` : ''}
                  {r.needed_in_days ? `${r.needed_in_days} days · ` : ''}{ago(r.created_at)}
                </span>
              </div>
              <p style={{ margin: '5px 0', fontSize: 12.5, whiteSpace: 'pre-wrap' }}>{r.brief}</p>

              {r.offers.length > 0 && (
                <p style={{ margin: '3px 0', fontSize: 11, color: C.muted }}>
                  You offered {r.offers[0].price_pi} Pi — {r.offers[0].status}
                </p>
              )}

              {r.status === 'open' && (
                replyTo === r.id ? (
                  <div style={{ background: C.surface, borderRadius: 8, padding: 10, marginTop: 8 }}>
                    <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
                      placeholder="Offer title" style={inp} />
                    <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
                      rows={3} placeholder="What exactly will they get?" style={{ ...inp, resize: 'vertical' }} />
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input value={form.price_pi} onChange={(e) => setForm({ ...form, price_pi: e.target.value })}
                        type="number" step="0.01" placeholder="Price (Pi)" style={inp} />
                      <input value={form.delivery_days} onChange={(e) => setForm({ ...form, delivery_days: e.target.value })}
                        type="number" placeholder="Days" style={inp} />
                      <input value={form.revisions} onChange={(e) => setForm({ ...form, revisions: e.target.value })}
                        type="number" placeholder="Revisions" style={inp} />
                    </div>
                    <MilestoneBuilder rows={msRows} setRows={setMsRows} totalPrice={form.price_pi} />
                    {msg && <p style={{ fontSize: 11.5, color: C.danger, margin: '0 0 6px' }}>{msg}</p>}
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => sendOffer(r.id)} disabled={busy}
                        style={{ ...btn, background: C.primary, color: '#fff', borderColor: C.primary, fontWeight: 700 }}>
                        {busy ? 'Sending…' : 'Send offer'}
                      </button>
                      <button onClick={() => { setReplyTo(null); setMsg(''); }} style={btn}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <button onClick={() => setReplyTo(r.id)}
                    style={{ ...btn, color: C.primary, borderColor: C.primary, fontWeight: 600, marginTop: 6 }}>
                    {'\u{1F4B0}'} Send an offer
                  </button>
                )
              )}
            </div>
          ))}
        </>
      )}

      {d.offers_received.length > 0 && (
        <>
          <p style={{ fontSize: 12.5, fontWeight: 700, margin: '14px 0 7px' }}>
            {'\u{1F4B0}'} Offers for you
          </p>
          {d.offers_received.map((o) => <OfferCard key={o.id} o={o} mine={false} />)}
        </>
      )}

      {d.requests_sent.length > 0 && (
        <>
          <p style={{ fontSize: 12.5, fontWeight: 700, margin: '14px 0 7px' }}>
            {'\u{1F4E4}'} Requests you sent
          </p>
          {d.requests_sent.map((r) => (
            <div key={r.id} style={{ background: '#fff', border: `1px solid ${C.border}`,
                                     borderRadius: 9, padding: '9px 12px', marginBottom: 6 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12.5, fontWeight: 600 }}>to @{r.freelancer}</span>
                <span style={{ fontSize: 11, color: r.status === 'open' ? C.gold : C.muted }}>
                  {r.status === 'open' ? 'waiting for reply' : r.status} · {ago(r.created_at)}
                </span>
              </div>
              <p style={{ margin: '4px 0 0', fontSize: 12, color: C.muted, whiteSpace: 'pre-wrap' }}>{r.brief}</p>
            </div>
          ))}
        </>
      )}

      {d.offers_sent.length > 0 && (
        <>
          <p style={{ fontSize: 12.5, fontWeight: 700, margin: '14px 0 7px' }}>
            {'\u{1F4E4}'} Offers you sent
          </p>
          {d.offers_sent.map((o) => <OfferCard key={o.id} o={o} mine />)}
        </>
      )}
    </div>
  );
}
